/** Label primitive. */
import * as React from 'react';
import { cn } from '@/lib/utils';

/** Props for {@link Label}. */
export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {}

/** Styled form label. */
const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <label
        ref={ref}
        className={cn(
          'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
          className,
        )}
        {...props}
      >
        {children}
      </label>
    );
  },
);
Label.displayName = 'Label';

export { Label };
